import { PortfolioStatements } from "types/Statements";
import { ActionType, getType } from "typesafe-actions";
import * as statementsActions from "./statementsActions";

export interface StatementsState {
  loading?: boolean;
  data?: PortfolioStatements[];
  error?: string;
}

export type StatementsActions = ActionType<typeof statementsActions>;

export default function statements(
  state: StatementsState = {},
  action: StatementsActions
) {
  switch (action.type) {
    case getType(statementsActions.load):
      return { ...state, loading: true };
    case getType(statementsActions.loadSuccess):
      const data = action.data?.map((d) => ({ ...d }));
      return { ...state, loading: false, data, error: undefined };
    case getType(statementsActions.loadFail):
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
